let HMR_IN_PROGRESS = false;

// I don't want to expose the vite/types to the whole repo yet,
// so ignore the TS error for now.
if (import.meta.hot) {
  import.meta.hot.on('vite:beforeUpdate', () => {
    HMR_IN_PROGRESS = true;
  });

  import.meta.hot.on('vite:afterUpdate', () => {
    HMR_IN_PROGRESS = false;
  });
}

export const isHmrInProgress = () => import.meta.env.DEV && HMR_IN_PROGRESS;
